module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "lr-intent-popup"
  }, [_c('div', {
    staticClass: "popup-container"
  }, [_c('div', {
    staticClass: "intent-close"
  }, [_c('button', {
    attrs: {
      "type": "button",
      "data-close": ""
    },
    on: {
      "click": _vm.decline
    }
  }, [_c('i', {
    staticClass: "fal fa-times"
  })])]), _vm._v(" "), _c('div', {
    staticClass: "popup-image",
    style: ('background-image: url(' + _vm.backgroundImage + ')')
  }), _vm._v(" "), _c('div', {
    staticClass: "popup-message"
  }, [_c('h2', [_vm._v("Please don't go yet!")]), _vm._v(" "), _c('p', [_vm._v("Just your signature will help save my home.")]), _vm._v(" "), _c('button', {
    staticClass: "action-btn",
    attrs: {
      "type": "button",
      "data-close": ""
    },
    on: {
      "click": _vm.confirm
    }
  }, [_vm._v("Ok let's do this!")]), _vm._v(" "), _c('button', {
    staticClass: "decline-btn",
    attrs: {
      "type": "button",
      "data-close": ""
    },
    on: {
      "click": _vm.decline
    }
  }, [_vm._v("Sorry I can't help")])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4308e4dc","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/string-replace-webpack-plugin/loader.js?id=a9gwdhtvlz!./~/string-replace-webpack-plugin/loader.js?id=zp0damlfgbk!./src/components/leaf-relief/IntentPopup.vue
// module id = 678
// module chunks = 0